<div
  id="app-wrapper"
  class="base-content-grid">
  <div
    id="page-loader"
    class="base-full-width">
    @if (loading$ | async) {
      <mat-progress-bar
        mode="indeterminate"
        class="breakout"></mat-progress-bar>
    }
  </div>

  @if ($isLoggedIn | async) {
    <ume-main-nav-wrap
      id="ume-top"
      class="base-full-width">
      <ume-navigation [items]="navigationItems()"></ume-navigation>
      <nav class="menu-right">
        @if (notUmeOps) {
          <button
            matButton
            matTooltip="Help"
            [matMenuTriggerFor]="aboutMenu">
            <span class="help-btn">Help</span>
          </button>

          @defer (on idle) {
            @if (notifications(); as notifications) {
              @if (notifications.entryBeans.length) {
                <button
                  matIconButton
                  matTooltip="Notifications"
                  class="notification-btn"
                  [matMenuTriggerFor]="notificationsList">
                  <mat-icon>notifications</mat-icon>
                  <span class="sign"></span>
                </button>

                <mat-menu
                  #notificationsList="matMenu"
                  class="custom-mat-menu"
                  xPosition="before">
                  <ume-user-notification-groups
                    [notifications]="notifications"
                    [canConnect]="notifications.canConnect || false"
                    [isMenu]="true"
                    [isPremium]="isPremium"
                    [isVirtualPremium]="isVirtualPremium"></ume-user-notification-groups>
                </mat-menu>
              }
            }
          }
        }

        <ume-profile-menu></ume-profile-menu>
      </nav>
    </ume-main-nav-wrap>

    <main id="ume-content">
      <router-outlet></router-outlet>
    </main>
  } @else {
    <router-outlet></router-outlet>
  }
</div>

<mat-menu
  #aboutMenu="matMenu"
  xPosition="before">
  @for (item of helpItems; track item.label) {
    @if (item.external) {
      <a
        mat-menu-item
        [target]="item.target || '_blank'"
        [href]="item.link">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.name }}</span>
      </a>
    } @else {
      <a
        mat-menu-item
        target="_self"
        [routerLink]="item.link | companyTypeBasedRoute">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.name }}</span>
      </a>
    }
  }

  <button
    mat-menu-item
    (click)="welcomeGuide()">
    Welcome guide
  </button>
</mat-menu>
